export enum RunMode {
    UNASSIGNED = 'unassigned',
    MAIN_CASHIER=  'main_cashier',
    CASHIER_2ND = 'cashier_2nd',
    TERMINAL_CASHIER  = 'terminal_cashier',
    TERMINAL_ORDER = 'terminal_order',
    // ดูอย่างเดียว — หน้าตาเหมือน terminal แต่สั่ง / เพิ่มรายการไม่ได้ (บล็อกทุก job)
    AUDIT = 'audit',
}